const json = {
  samples: [
    {
      product: { id: 12, name: "Twois", schedules: [], company_branch_ids: [] },
      schedule: {
        client_suite_id: 5,
        client_suite_name: "Test Suite 3",
        sample_information_id: 2,
        sample_information_name: "Test",
        client_specification_id: 7,
        client_specification_name: "Edible Suite"
      },
      data_fields: [
        {
          data_field_name: { id: 4, name: "ADC Code" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 2, name: "Bottom Depth" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 1, name: "Depth" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 7, name: "God" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 3, name: "Location" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 6, name: "Test" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        }
      ]
    },
    {
      product: { id: 12, name: "Twois", schedules: [], company_branch_ids: [] },
      schedule: {
        client_suite_id: 5,
        client_suite_name: "Test Suite 3",
        sample_information_id: 2,
        sample_information_name: "Test",
        client_specification_id: 7,
        client_specification_name: "Edible Suite"
      },
      data_fields: [
        {
          data_field_name: { id: 4, name: "ADC Code" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 2, name: "Bottom Depth" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 1, name: "Depth" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 7, name: "God" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 3, name: "Location" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 6, name: "Test" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        }
      ]
    },
    {
      product: { id: 17, name: "Is", schedules: [], company_branch_ids: [] },
      schedule: {
        client_suite_id: 5,
        client_suite_name: "Test Suite 3",
        sample_information_id: 2,
        sample_information_name: "Test",
        client_specification_id: 7,
        client_specification_name: "Edible Suite"
      },
      data_fields: [
        {
          data_field_name: { id: 4, name: "ADC Code" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 2, name: "Bottom Depth" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 1, name: "Depth" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 7, name: "God" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 3, name: "Location" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 6, name: "Test" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        }
      ]
    },
    {
      product: { id: 17, name: "Is", schedules: [], company_branch_ids: [] },
      schedule: {
        client_suite_id: 5,
        client_suite_name: "Test Suite 3",
        sample_information_id: 2,
        sample_information_name: "Test",
        client_specification_id: 7,
        client_specification_name: "Edible Suite"
      },
      data_fields: [
        {
          data_field_name: { id: 4, name: "ADC Code" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 2, name: "Bottom Depth" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 1, name: "Depth" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 7, name: "God" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 3, name: "Location" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 6, name: "Test" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        }
      ]
    },
    {
      product: { id: 17, name: "Is", schedules: [], company_branch_ids: [] },
      schedule: {
        client_suite_id: 5,
        client_suite_name: "Test Suite 3",
        sample_information_id: 2,
        sample_information_name: "Test",
        client_specification_id: 7,
        client_specification_name: "Edible Suite"
      },
      data_fields: [
        {
          data_field_name: { id: 4, name: "ADC Code" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 2, name: "Bottom Depth" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 1, name: "Depth" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 7, name: "God" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 3, name: "Location" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 6, name: "Test" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        }
      ]
    },
    {
      product: { id: 18, name: "Great", schedules: [], company_branch_ids: [] },
      schedule: {
        client_suite_id: 5,
        client_suite_name: "Test Suite 3",
        sample_information_id: 2,
        sample_information_name: "Test",
        client_specification_id: 7,
        client_specification_name: "Edible Suite"
      },
      data_fields: [
        {
          data_field_name: { id: 4, name: "ADC Code" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 2, name: "Bottom Depth" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 1, name: "Depth" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 7, name: "God" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 3, name: "Location" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 6, name: "Test" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        }
      ]
    },
    {
      product: { id: 13, name: "This", schedules: [], company_branch_ids: [] },
      schedule: {
        client_suite_id: 5,
        client_suite_name: "Test Suite 3",
        sample_information_id: 2,
        sample_information_name: "Test",
        client_specification_id: 7,
        client_specification_name: "Edible Suite"
      },
      data_fields: [
        {
          data_field_name: { id: 4, name: "ADC Code" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 2, name: "Bottom Depth" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 1, name: "Depth" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 7, name: "God" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 3, name: "Location" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 6, name: "Test" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        }
      ]
    },
    {
      product: { id: 13, name: "This", schedules: [], company_branch_ids: [] },
      schedule: {
        client_suite_id: 5,
        client_suite_name: "Test Suite 3",
        sample_information_id: 2,
        sample_information_name: "Test",
        client_specification_id: 7,
        client_specification_name: "Edible Suite"
      },
      data_fields: [
        {
          data_field_name: { id: 4, name: "ADC Code" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 2, name: "Bottom Depth" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 1, name: "Depth" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 7, name: "God" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 3, name: "Location" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        },
        {
          data_field_name: { id: 6, name: "Test" },
          mandatory: false,
          list_id: null,
          type: "free_text",
          default_value: ""
        }
      ]
    }
  ]
};

export { json };
